<script>
import { mapGetters } from 'vuex';
import request from '@/utils/request';
import PaginatedList from '@/views/components/PaginatedList';
import CouponsHeader from './components/CouponsHeader';
import Coupon from './components/Coupon';

export default {
  components: {
    CouponsHeader,
    Coupon,
  },
  extends: PaginatedList,
  computed: {
    ...mapGetters({
      items: 'coupons/list/getData',
      paginationParams: 'coupons/list/getPaginationParams',
      isLoadingCoupons: 'coupons/list/getIsLoading',
      isLoaded: 'coupons/list/getIsLoaded',
    }),
  },
  methods: {
    async closeModal(response) {
      try {
        this.isOpen = !this.isOpen;

        if (response) {
          await request.delete(`/coupons/${this.selectedItem.uuid}`);

          await this.navigate({
            timestamp: new Date().getTime(),
          });

          this.$notify({
            type: 'success',
            title: 'Επιτυχία',
            text: 'Το κουπόνι διαγράφτηκε επιτυχώς!!',
          });
        }
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
    async changeItemActive(selectedItem) {
      try {
        const isActive = !selectedItem.active;

        await request.put(`/coupons/${selectedItem.uuid}/active`, {
          active: !!isActive,
        });

        await this.navigate({
          timestamp: new Date().getTime(),
        });

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: isActive
            ? 'Το κουπόνι ενεργοποιήθηκε επιτυχώς!!'
            : 'Το κουπόνι δεν είναι ενεργό πλέον',
        });
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
  },
};
</script>
